import { graphql } from "../gql";

export const getCaseQueryDoc = graphql(`
  query getCase($id: ID!, $withClaim: Boolean = false) {
    case(id: $id) {
      ...CaseFragment
      ...CaseClaimFragment @include(if: $withClaim)
      queue {
        ...AskAutodorQueueFragment
      }
    }
  }
`);
